import type { GraphQLResponse } from 'relay-runtime';
import type {
	PayloadData,
	PayloadError,
	PayloadExtensions,
} from 'relay-runtime/lib/network/RelayNetworkTypes';

export interface IncrementalResult {
	id?: string;
	path: ReadonlyArray<string | number>;
	subPath?: ReadonlyArray<string | number>;
	errors?: PayloadError[] | undefined;
	extensions?: PayloadExtensions | undefined;
}

export type IncrementalResultWithData = IncrementalResult & {
	data: PayloadData;
};

export type IncrementalResultWithoutData = IncrementalResult & {
	errors: PayloadError[];
};

export type IncrementalResultWithItems = IncrementalResult & {
	items: ReadonlyArray<PayloadData>;
};

export interface CompletedResult {
	id: string;
	errors?: PayloadError[];
}

export interface PendingResult {
	id: string;
	path: ReadonlyArray<string | number>;
	label?: string;
}

export type GraphQLIncrementalResponse = {
	incremental?: ReadonlyArray<IncrementalResult>;
	completed?: ReadonlyArray<CompletedResult>;
	pending?: ReadonlyArray<PendingResult>;
	hasNext?: boolean;
	errors?: PayloadError[];
	extensions?: PayloadExtensions;
};

export type GraphQLMultipartResponsePayload = GraphQLResponse | GraphQLIncrementalResponse;

export type GraphQLMultipartResponsePayloadWithResponse = {
	response: Response;
	data: GraphQLMultipartResponsePayload;
};

export function isPayloadWithResponse(
	r: GraphQLMultipartResponsePayload | GraphQLMultipartResponsePayloadWithResponse | null,
): r is GraphQLMultipartResponsePayloadWithResponse {
	return r !== null && 'response' in r && r.response instanceof Response;
}
